import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import ImportFileMappingPreviewTable from "./components/ImportFileMappingPreviewTable";

import { SecondaryButton } from "components/ui";
import ImportFileMappingPreviewMobileTable from "./components/ImportFileMappingPreviewMobileTable";
import "./styles.css";

/**
 * @function ImportFileMappingPreviewWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview widget for the ImportFileNewTemplatePage.
 */
export default function ImportFileMappingPreviewWidget(props) {
        const { data } = useStateManager();
        const participantLength = data.achToParticipants.participants.length;

    return (
        <div className="import-file-mapping-preview-widget">
            <h2>Mapping Preview</h2>
            <p>Preview showing all rows ({participantLength}).</p>

            <div className="show-on-desktop">
                <ImportFileMappingPreviewTable />
            </div>
            <div className="show-on-mobile">
                <ImportFileMappingPreviewMobileTable />
                <DisabledPrompt>
                    <SecondaryButton className="show-more-button set-width"  text="Show More" />
                </DisabledPrompt>
            </div>
        </div>
    )
}
